export default __webpack_public_path__ + "static/media/vp_convention_center.8fd52a51.svg";